import { render, staticRenderFns } from "./GroupTypeGrid.vue?vue&type=template&id=10589445"
import script from "./GroupTypeGrid.vue?vue&type=script&lang=js"
export * from "./GroupTypeGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports